<template>
  <v-row dense>
    <v-col cols="6" md="3">
      <v-card variant="tonal" color="blue" class="pa-3">
        <div class="text-caption text-medium-emphasis">Date</div>
        <div class="text-h5 font-weight-bold">{{ formatData(stats.total_data_mb) }}</div>
        <div class="text-caption">{{ formatCost(stats.total_data_cost) }} {{ currency }}</div>
      </v-card>
    </v-col>
    <v-col cols="6" md="3">
      <v-card variant="tonal" color="green" class="pa-3">
        <div class="text-caption text-medium-emphasis">SMS</div>
        <div class="text-h5 font-weight-bold">{{ formatSMS(stats.total_sms) }}</div>
        <div class="text-caption">{{ formatCost(stats.total_sms_cost) }} {{ currency }}</div>
      </v-card>
    </v-col>
    <v-col cols="6" md="3">
      <v-card variant="tonal" color="orange" class="pa-3">
        <div class="text-caption text-medium-emphasis">Voce</div>
        <div class="text-h5 font-weight-bold">{{ formatMinutes(stats.total_voice_minutes) }}</div>
        <div class="text-caption">{{ formatCost(stats.total_voice_cost) }} {{ currency }}</div>
      </v-card>
    </v-col>
    <v-col cols="6" md="3">
      <v-card variant="tonal" color="red" class="pa-3">
        <div class="text-caption text-medium-emphasis">Cost Total</div>
        <div class="text-h5 font-weight-bold">{{ formatCost(stats.total_cost) }} {{ currency }}</div>
        <div class="text-caption">{{ stats.sim_count || 0 }} SIM-uri / {{ stats.record_count || 0 }} inregistrari</div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TrafficSummaryCards',
  props: {
    stats: { type: Object, default: () => ({}) },
    currency: { type: String, default: 'EUR' }
  },
  methods: {
    formatData(mb) {
      if (!mb || mb === 0) return '0 MB'
      const val = Number(mb)
      if (val >= 1024 * 1024) return (val / (1024 * 1024)).toFixed(2) + ' TB'
      if (val >= 1024) return (val / 1024).toFixed(2) + ' GB'
      return val.toFixed(2) + ' MB'
    },
    formatSMS(count) {
      if (!count || count === 0) return '0 msg'
      return Math.round(Number(count)) + ' msg'
    },
    formatMinutes(min) {
      if (!min || min === 0) return '0 min'
      const val = Number(min)
      if (val >= 60) return (val / 60).toFixed(1) + ' ore'
      return val.toFixed(1) + ' min'
    },
    formatCost(cost) {
      if (!cost || cost === 0) return '0.00'
      return Number(cost).toFixed(2)
    }
  }
}
</script>
